import { render } from "./AttachmentSection.vue?vue&type=template&id=0e6b753b&scoped=true"
import script from "./AttachmentSection.vue?vue&type=script&lang=js"
export * from "./AttachmentSection.vue?vue&type=script&lang=js"

import "./AttachmentSection.vue?vue&type=style&index=0&id=0e6b753b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e6b753b"

export default script